import React from 'react';
import './styles.css';
import { Collapse, Row, Col } from 'antd';

const { Panel } = Collapse;

const CollapseData = ({ header, text1, text2, text3, text4 }) => {
  return (
    <Row className="data-collapse-container">
      <Col span={24} style={{ marginTop: 20 }}>
        <Collapse
          defaultActiveKey={['dataCollapse']}
          bordered={false}
          className="site-collapse-custom-collapse"
        >
          <Panel
            key="dataCollapse"
            header={header}
            className="site-collapse-custom-panel"
          >
            <Row justify="center" style={{ paddingTop: 10 }}>
              <Col
                span={6}
                type="flex"
                align="middle"
                justify="center"
                className="input-form-container"
              >
                <Col span={18} type="flex" justify="center">
                  <div className="collapse-item">
                    <p>{text1}</p>
                  </div>
                </Col>
              </Col>
              <Col
                span={6}
                type="flex"
                align="middle"
                justify="center"
                className="input-form-container"
              >
                <Col span={18} type="flex" justify="center">
                  <div className="collapse-item">
                    <p>{text2}</p>
                  </div>
                </Col>
              </Col>
              <Col
                span={6}
                type="flex"
                align="middle"
                justify="center"
                className="input-form-container"
              >
                <Col span={18} type="flex" justify="center">
                  <div className="collapse-item">
                    <p>{text3}</p>
                  </div>
                </Col>
              </Col>
              <Col
                span={6}
                type="flex"
                align="middle"
                justify="center"
                className="input-form-container"
              >
                <Col span={18} type="flex" justify="center">
                  <div className="collapse-item">
                    <p>{text4}</p>
                  </div>
                </Col>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      </Col>
    </Row>
  );
};

CollapseData.defaultProps = {
  header: '',
  text1: '',
  text2: '',
  text3: '',
  text4: '',
};

export default CollapseData;
